<template>
  <div>
    <the-breadcrumbs></the-breadcrumbs>
    <page-content page-title="Nummer bearbeiten">
      <emergency-number-form
        :loading="loading"
        :number="number"
        :form-submitted="saveNumber"
        mode="edit"
      ></emergency-number-form>
    </page-content>
  </div>
</template>

<script>
import TheBreadcrumbs from "@/components/TheBreadcrumbs"
import PageContent from "@/components/PageContent"
import EmergencyNumberForm from "@/components/forms/EmergencyNumberForm"
import EmergencyNumbersRepository from "@/repositories/emergency_numbers_repository.js"
import ApiErrorHandlerMixin from "@/mixins/api_error_handler.js"

export default {
  metaInfo: {
    title: "Nummer bearbeiten"
  },
  components: {
    TheBreadcrumbs,
    PageContent,
    EmergencyNumberForm
  },
  mixins: [ApiErrorHandlerMixin],
  data() {
    return {
      loading: true,
      number: {}
    }
  },
  async created() {
    try {
      this.number = await EmergencyNumbersRepository.get(this.$route.params.id)
      this.loading = false
    } catch (error) {
      this.loading = false
      this.handleApiError(error)
    }
  },
  methods: {
    async saveNumber(number) {
      await EmergencyNumbersRepository.update(number.id, number)
      this.$router.push({ name: "EmergencyNumbersPage" })
    }
  }
}
</script>
